import { MobileOnlyOptions } from "./MobileOnlyOptions";
import type { LandingPageConfigOptions } from "landing/objects/LandingPageConfig";

export const LandingPageTemplate18: LandingPageConfigOptions = {
  consentAge: 19,
  ...MobileOnlyOptions,
};
